import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Barcode, BarcodeQuery, MemberCardQuery, MemberDetails, MemberQuery, CardToken, CardTokenQuery } from '@fgb/core';
import { BarcodeService } from '@fgb/core';
import { Observable, Subject, takeUntil } from 'rxjs';
import { MemberCard } from '@fgb/core';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-barcode',
  templateUrl: './barcode.component.html',
  styleUrls: ['./barcode.component.scss'],
})
export class BarcodeComponent implements OnInit {
  @Input() showTickets: boolean = true;
  @Input() isWalletPage: boolean = false;
  @Output() walletScrollHeight = new EventEmitter<number>();

  barcode$: Observable<Barcode>;
  card$: Observable<MemberCard | undefined>;
  memberDetails$: Observable<MemberDetails | undefined>;
  ecash$: Observable<number | undefined>;
  pointsBalance$: Observable<number | undefined>;
  cardToken$: Observable<CardToken | undefined>;
  populationName: string | undefined;
  population = Populations;
  private _destroyed$ = new Subject<void>();

  constructor(
    private barcodeService: BarcodeService,
    private barcodeQuery: BarcodeQuery,
    private memberCardQuery: MemberCardQuery,
    private memberQuery: MemberQuery,
    private cardTokenQuery: CardTokenQuery
  ) { }

  ngOnInit() {
    this.barcodeService.fetchBarcode().toPromise();
    this.barcode$ = this.barcodeQuery.select();
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.cardToken$ = this.cardTokenQuery.selectDefaultCard();
    this.populationName = this.memberQuery.getPopulationName();
    this.card$ = this.memberCardQuery.selectCurrentCard();
    this.card$.pipe(takeUntil(this._destroyed$)).subscribe((memberCard) => {
      if (memberCard) {
        if (memberCard.RetailDiscountLevel && !memberCard.DiscountLevel) {
          this.walletScrollHeight.emit(428);
        } else if (!memberCard.RetailDiscountLevel && memberCard.DiscountLevel) {
          this.walletScrollHeight.emit(428);
        } else if (memberCard.RetailDiscountLevel && memberCard.DiscountLevel) {
          this.walletScrollHeight.emit(448);
        } else {
          this.walletScrollHeight.emit(390);
        }
      }
    });
  }

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
